/* eslint-disable require-jsdoc */
const key = 'auth_token';

class AuthService {
    constructor(axios) {
        this.axios = axios;
    }

    getToken() {
        return localStorage.getItem(key);
    }

    setToken(value) {
        return localStorage.setItem(key, value);
    }

    async login({ username, password, email }) {
        return this.axios.post('/auth/moderatorLogin', {
            email,
            username,
            password });
    }

    async requestResetPass(email) {
        return this.axios.post('/auth/request-resetpass', { email });
    }

    async resetPass({password, token}) {
        return this.axios.post('/auth/moderatorResetPass', { token, password });
    }
    async setupPassword({ id, password }) {
        return this.axios.post('/auth/setupAccountPass', { id, password });
    }
    async invitation(token) {
        return this.axios.post('/auth/invitation', { token, status: 'Active' });
    }

    async getCallIncoming(phone, roomId) {
        return this.axios.get(`/calls/incommings?phone=${phone}&roomId=${roomId}`);
    }

    async actionCallIncoming(payload, isAccept) {
        return this.axios.post('/calls/actions', {
            ...payload,
            status: isAccept ? 'accept' : 'reject'
        });
    }
}

export default AuthService;
